import {Form} from 'react-bootstrap';

export default function CleaningTypeSelect({options = [], value, currentName, onChange, disabled, invalid}) {
    const selected = value ?? options.find(option => option.is_default)?.id ?? '';
    const visible = options.filter(option => option.status === 'ACTIVE' || String(option.id) === String(selected));
    return <Form.Select aria-label="Job type" value={selected} required disabled={disabled} isInvalid={invalid}
        onChange={event => onChange(event.target.value ? Number(event.target.value) : undefined)}>
        {!selected ? <option value="">Select Job Type</option> : null}
        {selected && !visible.some(option => String(option.id) === String(selected)) ? <option value={selected}>{currentName || 'Current Job Type'}</option> : null}
        {visible.map(option => <option key={option.id} value={option.id}>{option.name}{option.status === 'INACTIVE' ? ' (Inactive)' : ''}</option>)}
    </Form.Select>;
}
